/* lystia-certificate.js - <lystia-certificate> (T-E7-05, parity/certificate.md §3-4).
   Вибір номіналу (tween 320 мс + bump картки), валідація e-mail, лічильник привітання, loading 500 мс,
   стан «додано» (банер + кнопка «У кошику · переглянути»), додавання в кошик через LystiaCart (variant id, qty 1).
   Поля отримувача передаються як properties рядка кошика (A-074, нативний gift card recipient).
   Тексти приходять з data-* (locales). Формат ціни: ціле число, NBSP як роздільник тисяч, суфікс (валюта) береться з серверного рендера. */
if (!customElements.get('lystia-certificate')) {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const NBSP = ' ';
  const TWEEN_MS = 320;
  const LOADING_MS = 500;

  class LystiaCertificate extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.root = this.closest('.ab-cert') || document;
      this.card = this.root.querySelector('.ab-gift');
      this.cardAmount = this.root.querySelector('[data-cert-card]');
      this.total = this.form.querySelector('[data-cert-total]');
      this.chips = Array.from(this.form.querySelectorAll('[data-chip]'));
      this.submitBtn = this.form.querySelector('[data-submit]');
      this.label = this.submitBtn.querySelector('.btn__label');
      this.tpl = this.querySelector('template[data-added]');
      this.counter = this.form.querySelector('[data-cert-count]');
      this.max = parseInt(this.dataset.max, 10) || 200;
      this.added = false;
      this.cur = this.chips.find((c) => c.classList.contains('is-active')) || this.chips[0];

      const sample = (this.total.textContent || '').trim();
      const m = sample.match(/[^\d\s ]+$/);
      this.suffix = m ? m[0] : '';

      const el = (n) => this.form.elements[n];
      const email = el('email');
      this.email = { input: email, box: email.closest('.field'), err: email.closest('.field').querySelector('.field__error') };
      this.greet = el('greet');
      this.greet.maxLength = this.max;

      this.chips.forEach((c) => c.addEventListener('click', () => this.pick(c)));
      this.form.addEventListener('submit', this.onSubmit);
      this.email.input.addEventListener('input', () => this.setError(null));
      this.greet.addEventListener('input', this.updateCount);
      this.updateCount();
      this.applyState(new URLSearchParams(window.location.search).get('state'));
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      clearTimeout(this.timer);
      cancelAnimationFrame(this.raf1);
      cancelAnimationFrame(this.raf2);
    }

    /* Seed-стани прототипу (?state=error | ?state=success) */
    applyState(state) {
      if (state === 'error') {
        this.email.input.value = 'olena@mail';
        this.validate();
      }
      if (state === 'success') {
        this.email.input.value = 'olena@mail.com';
        this.setAdded(true);
      }
    }

    fmt(n) {
      const s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
      return this.suffix ? s + NBSP + this.suffix : s;
    }

    price(chip) {
      return Number(chip.dataset.price) || 0;
    }

    reduced() {
      return !!(document.lystia && document.lystia.reducedMotion && document.lystia.reducedMotion());
    }

    tween(node, from, to, key) {
      if (!node) return;
      if (this.reduced() || from === to) {
        node.textContent = this.fmt(to);
        return;
      }
      const t0 = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - t0) / TWEEN_MS);
        const e = 1 - Math.pow(1 - k, 3);
        node.textContent = this.fmt(from + (to - from) * e);
        if (k < 1) this[key] = requestAnimationFrame(step);
      };
      cancelAnimationFrame(this[key]);
      this[key] = requestAnimationFrame(step);
    }

    pick(chip) {
      if (chip === this.cur) return;
      const prev = this.price(this.cur);
      this.cur = chip;
      this.chips.forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.setAdded(false);
      const next = this.price(chip);
      this.tween(this.cardAmount, prev, next, 'raf1');
      this.tween(this.total, prev, next, 'raf2');
      if (this.card) {
        this.card.classList.remove('is-pop');
        void this.card.offsetWidth;
        this.card.classList.add('is-pop');
      }
    }

    updateCount = () => {
      if (this.counter) this.counter.textContent = this.greet.value.length + ' / ' + this.max;
    };

    setError(msg) {
      const f = this.email;
      f.box.classList.toggle('is-error', !!msg);
      f.err.textContent = msg || '';
      if (msg) {
        f.input.setAttribute('aria-invalid', 'true');
        f.input.setAttribute('aria-describedby', f.err.id);
      } else {
        f.input.removeAttribute('aria-invalid');
        f.input.removeAttribute('aria-describedby');
      }
    }

    validate() {
      const v = this.email.input.value.trim();
      this.setError(!v || !EMAIL_RE.test(v) ? this.dataset.msgEmail : null);
      return !this.email.box.classList.contains('is-error');
    }

    setLoading(on) {
      const b = this.submitBtn;
      b.classList.toggle('is-loading', on);
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      const sp = b.querySelector('.spinner');
      if (on && !sp) {
        const s = document.createElement('span');
        s.className = 'spinner';
        s.setAttribute('aria-hidden', 'true');
        b.insertBefore(s, b.firstChild);
      }
      if (!on && sp) sp.remove();
    }

    setAdded(on) {
      if (this.added === on) return;
      this.added = on;
      const b = this.submitBtn;
      if (on) {
        if (this.tpl) this.form.prepend(this.tpl.content.cloneNode(true));
        this.label.textContent = this.dataset.labelView;
        b.classList.remove('btn--primary');
        b.classList.add('btn--secondary');
      } else {
        const banner = this.form.querySelector('.ab-added');
        if (banner) banner.remove();
        this.label.textContent = this.dataset.labelAdd;
        b.classList.add('btn--primary');
        b.classList.remove('btn--secondary');
      }
    }

    openCart() {
      const ov = document.lystiaOverlay;
      if (ov && ov.has && ov.has('cart')) ov.open('cart');
      else window.location.href = this.dataset.cartUrl;
    }

    toast(text, icon, withAction) {
      const t = document.lystiaToast;
      if (!t) return;
      const o = { icon: icon };
      if (withAction) o.action = { label: this.dataset.toastAction, onClick: () => this.openCart() };
      t.show(text, o);
    }

    /* Нативна форма отримувача Shopify gift card: ключі Recipient email / Recipient name / Message + прапорець __shopify_send_gift_card_to_recipient.
       «Від кого» нативного ключа не має - окрема властивість рядка з підписом поля (data-from-key). */
    properties() {
      const v = (n) => (this.form.elements[n] ? this.form.elements[n].value.trim() : '');
      const p = { __shopify_send_gift_card_to_recipient: 'on', 'Recipient email': v('email') };
      if (v('to')) p['Recipient name'] = v('to');
      if (v('greet')) p['Message'] = v('greet').slice(0, this.max);
      if (v('from') && this.dataset.fromKey) p[this.dataset.fromKey] = v('from');
      return p;
    }

    onSubmit = (e) => {
      e.preventDefault();
      if (this.submitBtn.classList.contains('is-loading')) return;
      if (this.added) {
        this.openCart();
        return;
      }
      if (!this.validate()) {
        this.email.input.focus({ preventScroll: false });
        const f = this.email.box;
        f.scrollIntoView({ block: 'center', behavior: this.reduced() ? 'auto' : 'smooth' });
        return;
      }
      this.setLoading(true);
      const id = Number(this.cur.dataset.variantId);
      this.timer = setTimeout(async () => {
        try {
          if (id && window.LystiaCart) await window.LystiaCart.add({ id: id, properties: this.properties() });
          this.setLoading(false);
          this.toast(this.dataset.toast, 'check', true);
          this.setAdded(true);
        } catch (err) {
          this.setLoading(false);
          this.toast(this.dataset.toastFail, 'alert', false);
        }
      }, LOADING_MS);
    };
  }
  customElements.define('lystia-certificate', LystiaCertificate);
}
